/**
 * App Slider
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
"use strict";
import { isExists } from "@utils/validate";

/**
 * Slider
 * @param {this} param0
 */
export const Slider = function ({ el, options }) {
  this.target = $(el);
  /**
   * Define options
   */
  this.options = $.extend(
    {
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: false,
      dots: true,
      arrows: true,
      centerPadding: null,
      adaptiveHeight: true,
      pauseOnHover: false,
      draggable: false,
      autoplay: false,
      autoplaySpeed: 3500,
      prevArrow:
        '<button type="button" class="slide-prev"><i class="bi-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slide-next"><i class="bi-chevron-right"></i></button>',
      responsive: []
    },
    options
  );

  /**
   * Init function
   */
  this.init = function () {
    if (!isExists(el)) {
      return;
    }
    this.target.slick({ ...this.options });
  };

  return this.init();
};

/**
 * SliderThumbnail
 * @param {object} param0
 */
export const SliderThumbnail = function ({ elParent, elChild, optionParent, optionChild }) {
  this._elParent = $(elParent);
  this._elChild = $(elChild);
  /**
   * Define options
   */
  this.optionParent = $.extend(
    {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      draggable: false,
      asNavFor: elChild,
      prevArrow:
        '<button type="button" class="slide-prev-sm"><i class="bi-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slide-next-sm"><i class="bi-chevron-right"></i></button>'
    },
    optionParent
  );
  this.optionChild = $.extend(
    {
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: elParent,
      dots: false,
      arrows: false,
      infinite: false,
      focusOnSelect: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 575,
          settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 3
          }
        }
      ]
    },
    optionChild
  );

  /**
   * Init function
   */
  this.init = function () {
    if (!isExists(elParent) && !isExists(elChild)) {
      return;
    }
    this._elParent.slick({ ...this.optionParent });
    this._elChild.slick({ ...this.optionChild });
  };

  return this.init();
};
